// Pager số trang dùng chung cho Lionjob (Scraped Products + Listing Task).
// Hiển thị « ‹ 1 … 4 5 [6] 7 8 … 53 › » — bấm số để nhảy nhanh giữa nhiều trang.
export default function LionjobPager({ page, totalPages, onGo }) {
  const tp = Math.max(1, totalPages || 1);
  if (tp <= 1) return null;

  // Tập số trang cần hiện: đầu, cuối, và ±2 quanh trang hiện tại.
  const set = new Set([1, tp]);
  for (let i = page - 2; i <= page + 2; i++) if (i >= 1 && i <= tp) set.add(i);
  const nums = [...set].sort((a, b) => a - b);

  const items = [];
  let prev = 0;
  for (const n of nums) {
    if (n - prev > 1) items.push('…');
    items.push(n);
    prev = n;
  }

  return (
    <div className="lj-pager">
      <style>{PAGER_CSS}</style>
      <button className="lj-pgbtn" disabled={page <= 1} onClick={() => onGo(1)} title="Trang đầu">«</button>
      <button className="lj-pgbtn" disabled={page <= 1} onClick={() => onGo(page - 1)} title="Trước">‹</button>
      {items.map((it, i) =>
        it === '…' ? (
          <span key={'e' + i} className="lj-ell">…</span>
        ) : (
          <button key={it} className={'lj-pgbtn' + (it === page ? ' active' : '')} onClick={() => onGo(it)}>{it}</button>
        )
      )}
      <button className="lj-pgbtn" disabled={page >= tp} onClick={() => onGo(page + 1)} title="Sau">›</button>
      <button className="lj-pgbtn" disabled={page >= tp} onClick={() => onGo(tp)} title="Trang cuối">»</button>
    </div>
  );
}

const PAGER_CSS = `
.lj-pager{display:flex;gap:4px;align-items:center;flex-wrap:wrap;justify-content:center;margin-top:12px}
.lj-pgbtn{min-width:32px;height:32px;padding:0 8px;background:var(--panel);color:var(--text);border:1px solid var(--border);border-radius:8px;cursor:pointer;font-size:13px}
.lj-pgbtn:hover:not(:disabled){border-color:var(--accent)}
.lj-pgbtn:disabled{opacity:.4;cursor:not-allowed}
.lj-pgbtn.active{background:var(--accent);border-color:var(--accent);color:#fff;font-weight:600}
.lj-ell{color:var(--muted);padding:0 2px}
`;
